module.exports = __webpack_public_path__ + "img/participant-segments-icon.428c139f.svg";